import range from 'lodash/range';
import constants from './constants.js';

export default {
  approvalLevels: [
    'Passive',
    'PreTrip',
    'None',
    'Intent',
    'Quote'
  ],
  expiryMonths: [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12'
  ],
  expiryYears: range(2016, new Date().getFullYear() + 20),
  cardType: [
    {
      label: 'Visa',
      value: 'VI'
    },
    {
      label: 'American Express',
      value: 'AX'
    },
    {
      label: 'BC Card',
      value: 'BC'
    },
    {
      label: 'MasterCard',
      value: 'CA'
    },
    {
      label: 'Discover',
      value: 'DS'
    },
    {
      label: 'Diners Club',
      value: 'DC'
    },
    {
      label: 'Carta Si',
      value: 'T'
    },
    {
      label: 'Carte Bleue',
      value: 'R'
    },
    {
      label: 'Visa Electron',
      value: 'E'
    },
    {
      label: 'Japan Credit Bureau',
      value: 'JC'
    },
    {
      label: 'Maestro',
      value: 'TO'
    },
    {
      label: 'AirPlus Card',
      value: 'TP'
    }
  ],
  SegmentTypes: [
    'Flight',
    'Rail',
    'Car',
    'Hotel'
  ],
  AggregatorTypes: [
    'BookingDotCom',
    'Expedia'
  ],
  HotelSectorAggregatorTypes: [
    'SabreGds',
    'BookingDotCom',
    'Expedia'
  ],
  AirlinePolicyTypes: [
    'PreferredCarriers',
    'ShowAll'
  ],
  HotelPolicyTypes: [
    'ShowOnlyPreferred',
    'PreferredFirst'
  ],
  FlightTypes: [
    'Single',
    'Return'
  ],
  GdsFareSearchGroupType: [
    'Individual',
    'Bundled'
  ],
  GdsFareSearchSearchType: [
    'Unknown',
    'Branded',
    'NonBranded',
    'BrandedSingleFares',
    'BrandedMultipleFares',
    'BrandedOneWay',
    'BrandedSingleFaresOneWay',
    'BrandedMultipleFaresOneWay',
    'BrandedMultipleFaresPlusNDC',
    'BrandedSingleFaresPlusNDC'
  ],
  GDSProviders: [
    'Expedia',
    'Sabre',
    'Jetstar',
    'Rex',
    'Travelfusion',
    'AgentWare',
    'EventsAir',
    'FareLogix',
    'ExpediaRapid'
  ],
  HotelConfigurationRadius: [
    {
      label: 'N/A',
      value: null
    },
    {
      label: '2',
      value: 2
    },
    {
      label: '5',
      value: 5
    },
    {
      label: '10',
      value: 10
    },
    {
      label: '15',
      value: 15
    },
    {
      label: '25',
      value: 25
    },
    {
      label: '50',
      value: 50
    }
  ],
  RadiusOptions: [
    {
      label: '2',
      value: 2
    },
    {
      label: '5',
      value: 5
    },
    {
      label: '10',
      value: 10
    },
    {
      label: '15',
      value: 15
    },
    {
      label: '25',
      value: 25
    },
    {
      label: '50',
      value: 50
    }
  ],
  TravellerConfigurationSources: [
    {
      label: 'Tramada',
      value: 'Tramada'
    },
    {
      label: 'Sabre',
      value: 'Sabre'
    }
  ],
  PaymentTypes: [
    'Invoice',
    'VirtualCreditCard'
  ],
  SectorTypes: [
    'Flight',
    'Rail',
    'Hotel',
    'Car'
  ],
  PolicyTypes: [
    'Include',
    'Exclude'
  ],
  CompanyReferencesFlags: [
    'GuestTravellerTrue',
    'GuestTravellerFalse',
    'FlightInPolicy',
    'FlightOutPolicy',
    'HotelInPolicy',
    'HotelOutPolicy',
    'CarInPolicy',
    'CarOutPolicy',
    'RailInPolicy',
    'RailOutPolicy'
  ],
  GDSSettingsOptions: [
    'ExcludedCarriers',
    'AdditionalFareCodeRequests',
    'DiversityPercentage',
    'DiversityLowFareBucketOptions',
    'DiversityLowFareBucketFareCutOff',
    'DiversityPriceWeight',
    'DiversityTravelTimeWeight',
    'DiversityTimeOfDayWeight',
    'DiversityStopsNumberWeight',
    'DiversityTimeWindowHours',
    'DiversityTimeWindowPercentage',
    'DiversityOperatingDuplicateWeight',
    'DiversityCarrierPreferenceWeight',
    'DiversityCarrierPreferenceOnline',
    'DiversityCarrierPreferenceDefaultOptions',
    'DiversityInboundOutboundPairingWeight',
    'DiversityInboundOutboundPairingDuplicates',
    'FinishingRemarks',
    'Username',
    'Password',
    'AgentLogin-',
    'AgentPassword-',
    'SourceOrganization',
    'ServiceTag',
    'RailItineraryCount',
    'FlightItineraryCount',
    'OnlineIndicator',
    'PostBookingChangesEnabled',
    'EanTestAddressLine1',
    'RapidTestShopping',
    'RapidTestPriceCheck',
    'RapidTestBooking',
    'TraceId',
    'HotelPrepaidQualifier',
    'ExcludeBookingGeniusRates',
    'ExcludeDepositRates',
    'OnlineReissue',
    'DisableNDC',
    'OnlineNdcTicketing',
    'OnlineCancel',
    'OnlineTicketingReissue',
    'OnlineChange',
    'OnlineCancelSegment'
  ],
  SuppliersSettingsOptions: [
    'TravelAgentAccount'
  ],
  PaymentSuppliers: [
    'Sabre',
    'Trainline',
    'EuroStar'
  ],
  CarPolicyTypes: [
    'Include',
    'Exclude'
  ],
  DeliveryCollectionSupport: [
    'NotImported',
    'Unknown',
    'DeliveryAvailable',
    'CollectionAvailable',
    'DeliveryAndCollectionAvailable'
  ],
  DurationTypeOptions: [
    null,
    'TotalDuration',
    'AirTimeOnly',
    'SectorTime'
  ],
  TramadaInstances: [
    'AU',
    'NZ',
    'US',
    'EU',
    'Asia'
  ],
  VehicleAttributes: [
    'AirConditioning',
    'Automatic',
    'Doors',
    'Luggages',
    'Passengers',
    'Size'
  ],
  CountryPairTypes: [
    'Include',
    'Exclude'
  ],
  HotelAggregators: [
    // { value: 'Sabre', label: 'Sabre' }, //This is the default value on Lightning. No need to have it here.
    { value: 'Expedia', label: 'Expedia' },
    { value: 'Bedsonline', label: 'Bedsonline' },
    { value: 'BookingDotCom', label: 'Booking.com' },
  ],
  PrepaidQualifierTypes: [
    'IncludePrepaid',
    'ExcludePrepaid',
    'PrepaidOnly'
  ],
  OptionalServiceIndustryTypes: [
    { value: 'A', label: 'Air Transportation' },
    { value: 'B', label: 'Surface Transportation / Non Air Services' },
    { value: 'C', label: 'Baggage' },
    { value: 'D', label: 'Financial Impact' },
    { value: 'E', label: 'Airport Services' },
    { value: 'F', label: 'Merchandise' },
    { value: 'G', label: 'In-flight Services' },
    { value: 'H', label: 'Reserved for future ATPCO use' },
    { value: 'I', label: 'Individual Airline Use' }
  ],
  VirtualCreditCardIssuerReportKeys: {
    AirPlus: [
      "DBI_AE",
      "DBI_DS",
      "DBI_IK",
      "DBI_KS",
      "DBI_PK",
      "DBI_PR",
      "DBI_KZ"
    ],
    AmericanExpress: [
      "UDF6",
      "UDF7",
      "UDF8",
      "UDF9"
    ],
    Citi: [
      "REF1",
      "REF2",
      "REF3",
      "REF4",
      "REF5",
      "REF6",
      "REF7",
      "REF8",
      "REF9",
      "REF10"
    ],
    CommonwealthBank: [
      "REF1",
      "REF2",
      "REF3",
      "REF4",
      "REF5",
      "PC",
      "CC",
      "EN"
    ],
    DinersClub: [
      "REF1",
      "REF2",
      "REF3",
      "REF4",
      "REF5",
      "REF6",
      "REF7",
      "REF8",
      "REF9",
      "REF10",
      "REF11",
      "REF12",
      "REF13",
      "REF14",
      "REF15"
    ],
    Westpac: [
      "REF1",
      "REF2",
      "REF3",
      "REF4",
      "REF5",
      "PC",
      "CC",
      "EN"
    ],
    ANZ: [
      "EMPLOYEEID",
      "GLCODE",
      "PROJECTCODE",
      "REF4",
      "COSTCENTER"
    ]
  },
  VirtualCreditCardIssuers:[
    {
      label: 'Air Plus',
      value: 'AirPlus',
    },
    {
      label: 'American Express',
      value: 'AmericanExpress'
    },
    {
      label: 'ANZ',
      value: 'ANZ'
    },
    {
      label: 'Bank of America',
      value: 'BankOfAmerica'
    },
    {
      label: 'Citi',
      value: 'Citi'
    },
    {
      label: 'Commonwealth Bank',
      value: 'CommonwealthBank'
    },
    {
      label: 'Diners Club',
      value: 'DinersClub'
    },
    {
      label: 'Westpac',
      value: 'Westpac'
    }
  ],
  SabreCslRatePlanCodeOptions: [
    "Association",
    "Club",
    "Convention",
    "Corporate",
    "DayRate",
    "DistressedInventory",
    "FamilyPlan",
    "Government",
    "Military",
    "Negotiated",
    "Package",
    "Promotional",
    "Rack",
    "SeniorCitizen",
    "TourWholesale",
    "TravelIndustry",
    "Weekend",
    "LastRoomAvailable",
    "NonLastRoomAvailable",
    "Consortia",
    "Group",
    "Contract",
    "PromotionalPackage",
    "Published",
    "Net",
    "MultiDayPackage",
    "Weekly",
    "Monthly",
    "StandardRedemptionRate",
    "DiscountRedemptionRate",
    "CashAndPointsRedemptionRate",
    "PointUpgradeRedemptionRate",
    "CashUpgradeRedemptionRate"
  ],
  DebtorProductOptions: [
    {
      label: 'Lightning Book',
      value: constants.PRODUCT.LIGHTNINGBOOK
    },
    {
      label: 'CTM Mobile',
      value: constants.PRODUCT.CTMMOBILE
    },
    {
      label: 'CTM Portal',
      value: constants.PRODUCT.CTMPORTAL
    },
    {
      label: 'CTM Approve',
      value: constants.PRODUCT.CTMAPPROVE
    },
    {
      label: 'Hotel Review',
      value: constants.PRODUCT.HOTELREVIEW
    },
    {
      label: 'Ride Share',
      value: constants.PRODUCT.RIDESHARE
    },
    {
      label: 'Risk',
      value: constants.PRODUCT.RISK
    },
    {
      label: 'Trips',
      value: constants.PRODUCT.TRIPS
    }
  ],
  UserRoles: [
    "Traveller",
    "Travel Arranger",
    "Client Manager",
    "Demo",
  ],
  MinimumRiskRatings:[
    "Negligible",
    "Low",
    "Moderate",
    "High",
    "Extreme"
  ],
  ProfileTools:[
    "Tramada",
    "Concur",
    "Serko",
    "Cytric"
  ]
}



// WEBPACK FOOTER //
// ./src/config/fieldOptionsConfig.js